export default __webpack_public_path__ + "static/media/arrow-right.8e52cae8.svg";